module.exports = __webpack_public_path__ + "img/studio.136c0a66.png";